<!--
    @file:车辆定位 / 车辆追踪模块
-->
<template>
    <div id="car-tracing">
    <v-ws v-on:onopen="createVehicleChoose" :sendMessage="sendMessage" v-on:vehicle_choose="changeSelectData" v-on:vehicle_search="changeSearchData" ></v-ws>
        <div class="container">
            <el-row :gutter="15">
                <el-col :span="10" >
                    <v-search v-on:search="createVehicleSearch" v-on:select="searchSelectCurrent" :serchData="serchData"></v-search>
                </el-col>
                <el-col :span="14"  >
                    <div class="map">
                        <v-amap :poits="poits" v-loading="loading"></v-amap>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
import search from '../plugins/search';
import amapMarker from './map/amap-marker';
import ws from '../plugins/ws';
export default {
    name: 'car-tracing',
    components: {
        'v-search': search,
        'v-amap': amapMarker,
        'v-ws': ws
    },
    data () {
        return {
            loading: false,
            websocket: {},
            tick_heartpac: null,
            sendMessage: null,
            poits: null,
            serchData: {},
            firstLoad: true
        };
    },
    methods: {
        changeSelectData (data) {
            this.poits = data;
            if (this.firstLoad) {
                this.sendMessage = {
                    topic: 'vehicle_search',
                    action: 'create',
                    data: {
                        battery_code: data.battery_code,
                        plate_number: data.plate_number,
                        production_vehicle_no: data.production_vehicle_no
                    }
                };
                this.firstLoad = false;
            }
        },
        changeSearchData (data) {
            this.serchData = data;
        },
        createVehicleChoose (id) {
            if (!id) {
                id = localStorage.getItem('SELECTCARID');
            }
            this.sendMessage = {
                topic: 'vehicle_choose',
                action: 'create',
                data: {
                    id: id
                }
            };
        },
        createVehicleSearch (value) {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: value
            };
        },
        searchSelectCurrent (car) {
            this.poits = car;
            localStorage.setItem('SELECTCARID', car.id);
            this.createVehicleChoose(car.id);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
    margin: 15px  0 0 0;
    height: 80vh;
    min-height: 680px;
}
.map{
    height: 80vh;
    min-height: 680px;
    padding: 5px;
    box-sizing: border-box;
    background-color: #fff;
}
.el-radio__inner{
    width: 14px;
    height: 14px;
}
.el-radio__label{
    display: none;
}
.el-radio__inner:hover{
    border-color: #5182e4;
}
.el-radio__inner::after{
    width: 5px;
    height: 5px;
    background-color: #5182e4;
}
.el-radio__input.is-checked .el-radio__inner{
    background-color: #fff;
    border-color: #5182e4;
}
</style>



// WEBPACK FOOTER //
// car-tracing.vue?6f2924d2